import { ManagementType } from "types/common";
import { USER_GROUPS } from "constants/roles";
import { useAppSelector } from "hooks/reduxHooks";
import {
  selectPatientsLimit,
  selectClinicUsersOffset,
  selectPatientsTotal,
  selectPatientsOffset,
  selectClinicUsersTotal,
  selectClinicUsersLimit,
} from "store/ClinicianStore/selectors";
import {
  selectClinicPatientsLimit,
  selectClinicPatientsOffset,
  selectClinicPatientsTotal,
} from "store/PatientStore/selectors";
import Pagination from "@mui/material/Pagination";
import Box from "@mui/material/Box";

type PaginationByRoleProps = {
  managementType?: ManagementType;
  currentClinician: any;
  clinicPatientsLoading: any;
  hasMorePatients: any;
  onLoadMorePatients: any;
  clinicianPatientsLoading: any;
  hasMoreClinicianPatients: any;
  onLoadMoreClinicianPatients: any;
  loading: any;
  onLoadMore: any;
};

const PaginationByRole = ({
  currentClinician,
  managementType,
  clinicPatientsLoading,
  hasMorePatients,
  onLoadMorePatients,
  clinicianPatientsLoading,
  hasMoreClinicianPatients,
  onLoadMoreClinicianPatients,
  loading,
  onLoadMore,
}: PaginationByRoleProps) => {
  const clinicianPatientsOffset: number = useAppSelector(selectPatientsOffset);
  const clinicianPatientsTotal: number = useAppSelector(selectPatientsTotal);
  const clinicianPatientsLimit: number = useAppSelector(selectPatientsLimit);
  const clinicianUsersOffset: number = useAppSelector(selectClinicUsersOffset);
  const clinicianUsersTotal: number = useAppSelector(selectClinicUsersTotal);
  const clinicianUsersLimit: number = useAppSelector(selectClinicUsersLimit);
  const patientsOffset: number = useAppSelector(selectClinicPatientsOffset);
  const patientsTotal: number = useAppSelector(selectClinicPatientsTotal);
  const patientsLimit: number = useAppSelector(selectClinicPatientsLimit);

  return (
    <>
      {(currentClinician?.role?.includes(USER_GROUPS.CLINIC_ASSISTANT) ||
        currentClinician?.role?.includes(USER_GROUPS.CLINIC_TEAM_LEAD)) &&
        managementType == ManagementType.PATIENT && (
          <Box display="flex" justifyContent="flex-end" marginTop={4}>
            <Pagination
              variant="outlined"
              shape="rounded"
              page={
                clinicianPatientsOffset >= clinicianPatientsTotal
                  ? -1
                  : clinicianPatientsOffset / clinicianPatientsLimit + 1
              }
              count={Math.ceil(clinicianPatientsTotal / clinicianPatientsLimit)}
              disabled={clinicPatientsLoading || !hasMorePatients}
              onChange={onLoadMorePatients}
            />
          </Box>
        )}
      {currentClinician?.role?.includes(USER_GROUPS.CLINIC_TEAM_MEMBER) &&
        managementType == ManagementType.PATIENT_CARE && (
          <Box display="flex" justifyContent="flex-end" marginTop={4}>
            <Pagination
              variant="outlined"
              shape="rounded"
              page={
                patientsOffset >= patientsTotal
                  ? -1
                  : patientsOffset / patientsLimit + 1
              }
              count={Math.ceil(patientsTotal / patientsLimit)}
              disabled={clinicianPatientsLoading || !hasMoreClinicianPatients}
              onChange={onLoadMoreClinicianPatients}
            />
          </Box>
        )}
      {managementType == ManagementType.USER && (
        <Box display="flex" justifyContent="flex-end" marginTop={4}>
          <Pagination
            variant="outlined"
            shape="rounded"
            page={
              clinicianUsersOffset >= clinicianUsersTotal
                ? -1
                : clinicianUsersOffset / clinicianUsersLimit + 1
            }
            count={Math.ceil(clinicianUsersTotal / clinicianUsersLimit)}
            disabled={loading}
            onChange={(event, value) => onLoadMore(value)}
          />
        </Box>
      )}
    </>
  );
};

export default PaginationByRole;
